import { defineType } from 'sanity'
import getPageInfo, { seoGroup } from '../../objects/pageInfo'

export default defineType({
  title: 'Cart',
  name: 'cart',
  type: 'document',
  groups: [
    {
      name: 'content',
      title: 'Content',
      default: true,
    },
    seoGroup,
  ],
  fields: [getPageInfo({ lockCanonical: true })],
  preview: {
    select: {
      pageInfo: 'pageInfo',
    },
    prepare(selection) {
      const { title = 'New Page', description: subtitle = '' } =
        selection.pageInfo || {}
      return {
        title,
        subtitle,
      }
    },
  },
})